import _ from 'lodash';
import { AnyAction } from 'redux';
import { singleEntityDefaultState, SingleEntityState } from '../entities/types/SingleEntityState';
import {
    FAILURE_COMMISSION_INVOICES_BY_FILTER,
    FAILURE_COMMISSION_INVOICES_BY_FILTER_ID,
    FAILURE_COMMISSION_INVOICE_DETAILS_PDF,
    FAILURE_COMMISSION_INVOICE_FILTERS,
    FAILURE_COMMISSION_INVOICE_PDF,
    FAILURE_CREATE_NEW_COMMISSION_INVOICE,
    FAILURE_CREATE_NEW_COMMISSION_INVOICE_FILTER,
    FAILURE_DELETE_COMMISSION_INVOICE_FILTER,
    FAILURE_FETCH_COMMISSION_INVOICE_DETAILS,
    FAILURE_UPDATE_COMMISSION_INVOICE_FILTER,
    REQUEST_CLEAR_COMMISSION_INVOICE_DETAILS,
    REQUEST_COMMISSION_INVOICES_BY_FILTER,
    REQUEST_COMMISSION_INVOICES_BY_FILTER_ID,
    REQUEST_COMMISSION_INVOICE_DETAILS_PDF,
    REQUEST_COMMISSION_INVOICE_FILTERS,
    REQUEST_COMMISSION_INVOICE_PDF,
    REQUEST_CREATE_NEW_COMMISSION_INVOICE,
    REQUEST_CREATE_NEW_COMMISSION_INVOICE_FILTER,
    REQUEST_DELETE_COMMISSION_INVOICE_FILTER,
    REQUEST_FETCH_COMMISSION_INVOICE_DETAILS,
    REQUEST_UPDATE_COMMISSION_INVOICE_FILTER,
    SUCCESS_COMMISSION_INVOICES_BY_FILTER,
    SUCCESS_COMMISSION_INVOICES_BY_FILTER_ID,
    SUCCESS_COMMISSION_INVOICE_DETAILS_PDF,
    SUCCESS_COMMISSION_INVOICE_FILTERS,
    SUCCESS_COMMISSION_INVOICE_PDF,
    SUCCESS_CREATE_NEW_COMMISSION_INVOICE,
    SUCCESS_CREATE_NEW_COMMISSION_INVOICE_FILTER,
    SUCCESS_DELETE_COMMISSION_INVOICE_FILTER,
    SUCCESS_FETCH_COMMISSION_INVOICE_DETAILS,
    SUCCESS_UPDATE_COMMISSION_INVOICE_FILTER,
} from './actions';

export function adminCommissionInvoicesReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_COMMISSION_INVOICES_BY_FILTER:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_COMMISSION_INVOICES_BY_FILTER:
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });

        case FAILURE_COMMISSION_INVOICES_BY_FILTER:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        case REQUEST_COMMISSION_INVOICES_BY_FILTER_ID:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_COMMISSION_INVOICES_BY_FILTER_ID:
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        case FAILURE_COMMISSION_INVOICES_BY_FILTER_ID:
            return _.assign({}, state, { isFetching: false, error: action.error, content: undefined });
        case REQUEST_CREATE_NEW_COMMISSION_INVOICE:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CREATE_NEW_COMMISSION_INVOICE:
            return _.assign({}, state, { isFetching: false, error: undefined });
        case FAILURE_CREATE_NEW_COMMISSION_INVOICE:
            return _.assign({}, state, { isFetching: false, error: action.error, content: undefined });
        case REQUEST_COMMISSION_INVOICE_PDF:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_COMMISSION_INVOICE_PDF:
            return _.assign({}, state, { isFetching: false, error: undefined });
        case FAILURE_COMMISSION_INVOICE_PDF:
            return _.assign({}, state, { isFetching: false, error: action.error, content: undefined });
        case REQUEST_COMMISSION_INVOICE_DETAILS_PDF:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_COMMISSION_INVOICE_DETAILS_PDF:
            return _.assign({}, state, { isFetching: false, error: undefined });
        case FAILURE_COMMISSION_INVOICE_DETAILS_PDF:
            return _.assign({}, state, { isFetching: false, error: action.error, content: undefined });
        default:
            return state;
    }
}

export function adminCommissionInvoiceFiltersReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_COMMISSION_INVOICE_FILTERS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_COMMISSION_INVOICE_FILTERS:
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        case FAILURE_COMMISSION_INVOICE_FILTERS:
            return _.assign({}, state, { isFetching: false, error: action.error });
        case REQUEST_CREATE_NEW_COMMISSION_INVOICE_FILTER:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CREATE_NEW_COMMISSION_INVOICE_FILTER:
            return _.assign({}, state, {
                isFetching: false,
                error: undefined,
            });
        case FAILURE_CREATE_NEW_COMMISSION_INVOICE_FILTER:
            return _.assign({}, state, { isFetching: false, error: action.error });
        case REQUEST_UPDATE_COMMISSION_INVOICE_FILTER:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_UPDATE_COMMISSION_INVOICE_FILTER:
            return _.assign({}, state, {
                isFetching: false,
                error: undefined,
            });
        case FAILURE_UPDATE_COMMISSION_INVOICE_FILTER:
            return _.assign({}, state, { isFetching: false, error: action.error });
        case REQUEST_DELETE_COMMISSION_INVOICE_FILTER:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_DELETE_COMMISSION_INVOICE_FILTER:
            return _.assign({}, state, {
                isFetching: false,
                error: undefined,
            });
        case FAILURE_DELETE_COMMISSION_INVOICE_FILTER:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}

export function adminCommissionInvoiceDetailsReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_FETCH_COMMISSION_INVOICE_DETAILS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_FETCH_COMMISSION_INVOICE_DETAILS:
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        case FAILURE_FETCH_COMMISSION_INVOICE_DETAILS:
            return _.assign({}, state, { isFetching: false, error: action.error });
        case REQUEST_CLEAR_COMMISSION_INVOICE_DETAILS:
            return _.assign({}, state, { isFetching: false, error: undefined, content: undefined });
        default:
            return state;
    }
}
